(function (w, d) {
	const config = {
		backdrop: {
			hide: 'backdrop_hidden',
		},
		cookie: {
			hide: 'popup-cookie_hidden',
		},
		cookieBox: {
			open: 'popup-cookie__box_open',
		},
		cookieCounter: {
			expired: 'is-counter-expired',
		},
		cookieDesc: {
			hide: 'popup-cookie__description_hidden',
		},
		policy: {
			accepted: 'policy-accepted',
			essential: 'policy-essential',
			statistics: 'policy-statistics',
			advertising: 'policy-advertising',
		},
		button: {
			hide: 'button_hidden',
			inverted: 'button_inverted',
		}
	};
	const backdrop = d.querySelector('.js-backdrop');
	const cookie = d.querySelector('.js-popup-cookie');
	const cookieCounter = d.querySelector('.js-popup-cookie-counter');
	const checkboxes = d.querySelectorAll('.js-popup-cookie-checkbox');
	const buttonClose = d.querySelector('.js-button-cookie-close');
	const buttonManageCookie = d.querySelector('.js-button-manage-cookie');
	const buttonAccept = d.querySelector('.js-button-cookie-accept-selected');
	const buttonAcceptAll = d.querySelector('.js-button-cookie-accept-all');
	const isProduction = process.env.NODE_ENV !== 'development';
	const {antifraud} = w;
	let perfectScrollbar;

	if (!cookie) return;

	startApp();
	setListeners();

	function startApp() {
		const cookieBody = d.querySelector('.js-popup-cookie-body');
		perfectScrollbar = new PerfectScrollbar(cookieBody);
		setCookie(config.policy.essential, JSON.stringify(true), {path: '/'});

		if (!getCookie(config.policy.accepted)) {
			showCookie();
		} else {
			if (getCookie(config.policy.advertising)) {
				setAdvertisingScripts();
			}
			if (getCookie(config.policy.statistics)) {
				setStatisticsScripts();
			}
		}
	}

	function setListeners() {
		buttonManageCookie.addEventListener('click', visibilityManageCookie);
		buttonClose.addEventListener('click', visibilityManageCookie);
		buttonAccept.addEventListener('click', hideCookie);
		buttonAcceptAll.addEventListener('click', acceptAllCookie);
	}

	function visibilityManageCookie() {
		const cookieBox = d.querySelector('.js-popup-cookie-box');
		const cookieDescDesktop = d.querySelector('.js-popup-cookie-description-desktop');
		const cookieDescFull = d.querySelector('.js-popup-cookie-description-full');
		const isOpen = JSON.parse(cookieBox.dataset.popupCookieOpen);

		cookieBox.classList.toggle(config.cookieBox.open);
		cookieDescFull.classList.toggle(config.cookieDesc.hide);
		cookieDescDesktop.classList.toggle(config.cookieDesc.hide);
		buttonClose.classList.toggle(config.button.hide);
		buttonManageCookie.classList.toggle(config.button.hide);
		buttonAccept.classList.toggle(config.button.hide);
		buttonAcceptAll.classList.toggle(config.button.inverted);
		cookieBox.dataset.popupCookieOpen = !isOpen;
		if (perfectScrollbar) {
			perfectScrollbar.update();
		}
	}

	function acceptAllCookie() {
		checkboxes.forEach(checkbox => {
			checkbox.checked = true;
		})
		hideCookie();
	}

	function showCookie() {
		cookie.classList.remove(config.cookie.hide);

		if (getCookie(config.cookieCounter.expired)) {
			cookieCounter.innerHTML = 'Website is enabled';
		} else {
			initCounter();
			backdrop.classList.remove(config.backdrop.hide);
		}
	}

	function hideCookie() {
		cookie.classList.add(config.cookie.hide);
		scriptsFilter();
	}

	function scriptsFilter() {
		const expiresInYear = new Date().setFullYear(new Date().getFullYear() + 1);
		const cookieOptions = {
			...(isProduction && {domain: 'covery.ai'}),
			path: '/',
			expires: expiresInYear,
		};

		setCookie(config.policy.accepted, JSON.stringify(true), cookieOptions);

		checkboxes.forEach(checkbox => {
			if (checkbox.checked && checkbox.id !== config.policy.essential) {
				setCookie(checkbox.id, JSON.stringify(true), cookieOptions);

				switch (checkbox.id) {
					case config.policy.advertising:
						setAdvertisingScripts();
						break;
					case config.policy.statistics:
						setStatisticsScripts();
						break;
				}
			}
		})
	}

	function initCounter() {
		let seconds = 20;
		let counterInterval;

		startCounter();
		counterListeners('addEventListener');

		function startCounter() {
			counterInterval = w.setInterval(CounterHandler, 1000);
		}

		function resetCounter() {
			w.clearInterval(counterInterval);
		}

		function counterListeners(actionType) {
			w[actionType]('focus', startCounter);
			w[actionType]('blur', resetCounter);
		}

		function CounterHandler() {
			if (seconds === 0) {
				backdrop.classList.add(config.backdrop.hide);
				cookieCounter.innerHTML = 'Website is enabled';

				setCookie(config.cookieCounter.expired, JSON.stringify(true), {...(isProduction && {domain: 'covery.ai'}), path: '/'});
				counterListeners('removeEventListener');
				resetCounter();
			} else {
				cookieCounter.innerHTML = `Website will be enabled in ${seconds}&nbsp;seconds`;
				seconds--;
			}
		}
	}

	function setCookie(name, value, options) {
		options = options || {};

		let expires = options.expires;

		if (typeof expires == 'number' && expires) {
			const date = new Date();
			/** Expires in seconds */
			date.setTime(date.getTime() + expires * 1000);
			expires = options.expires = date;
		}
		if (expires && expires.toUTCString) {
			options.expires = expires.toUTCString();
		}

		value = encodeURIComponent(value);

		let updatedCookie = name + "=" + value;

		/** Add all parameters to cookie (domain, secure, path etc.) */
		for (let propName in options) {
			if (options.hasOwnProperty(propName)) {
				updatedCookie += "; " + propName;
				let propValue = options[propName];
				if (propValue !== true) {
					updatedCookie += "=" + propValue;
				}
			}
		}

		d.cookie = updatedCookie;
	}

	function setStatisticsScripts() {
		if (!antifraud) return;
		if (antifraud.hasOwnProperty('createAnalyticsScripts')) {
			antifraud.createAnalyticsScripts();
		}
		if (antifraud.hasOwnProperty('createHotjarScripts')) {
			antifraud.createHotjarScripts();
		}
	}

	function setAdvertisingScripts() {
		if (antifraud && antifraud.hasOwnProperty('createGtagScripts')) {
			antifraud.createGtagScripts();
		}
	}
})(window, document)
